<template>
    <div class="clothes-color">
        <div class="title">比赛服颜色</div>
        <div class="content">
            <div class="item flex-center">
                <div class="label">上衣</div>
                <div class="value">
                    <input type="text" v-model="teamColor.shirtColor" placeholder="请输入上衣颜色" :disabled="lockListOnStage == 1">
                </div>
            </div>
             <div class="item flex-center">
                <div class="label">短裤</div>
                <div class="value">
                    <input type="text" v-model="teamColor.shortColor" placeholder="请输入短裤颜色" :disabled="lockListOnStage == 1">
                </div>
            </div>
            <div class="item flex-center">
                <div class="label">球袜</div>
                <div class="value">
                    <input type="text" v-model="teamColor.sockColor" placeholder="请输入球袜颜色" :disabled="lockListOnStage == 1">
                </div>
            </div>
        </div>
        <div class="title">守门员服颜色</div>
        <div class="content">
            <div class="item flex-center">
                <div class="label">上衣</div>
                <div class="value">
                    <input type="text" v-model="goalkeeperColor.shirtColor" placeholder="请输入上衣颜色" :disabled="lockListOnStage == 1">
                </div>
            </div>
            <div class="item flex-center">
                <div class="label">短裤</div>
                <div class="value">
                    <input type="text" v-model="goalkeeperColor.shortColor" placeholder="请输入短裤颜色" :disabled="lockListOnStage == 1">
                </div>
            </div>
            <div class="item flex-center">
                <div class="label">球袜</div>
                <div class="value">
                    <input type="text" v-model="goalkeeperColor.sockColor" placeholder="请输入球袜颜色" :disabled="lockListOnStage == 1">
                </div>
            </div>
        </div>
        <div class="title">替补背心</div>
        <div class="content">
            <div class="item flex-center">
                <div class="label">替补背心</div>
                <div class="value">
                    <input type="text" v-model="vest" placeholder="请输入替补背心颜色" :disabled="lockListOnStage == 1">
                </div>
            </div>
        </div>
        
        <!-- <div class="footer">
            <div class="btn" @click="save">保存</div>
        </div> -->
        <footer-btn @click="save" :btnText="btnText" :showDisable="lockListOnStage == 1" disableLabel="无法更新" disableValue="比赛已检录，无法更新队服颜色"></footer-btn>
    </div>
</template>

<script>
import FooterBtn from './footer-btn.vue'
import { getTeamClothesColors, updateClothesColors } from '@/api/match-team-game'
export default {
    components: {
        FooterBtn
    },
    data() {
        return {
            teamColor: {
                shirtColor: '',
                shortColor: '',
                sockColor: ''
            },
            goalkeeperColor: {
                shirtColor: '',
                shortColor: '',
                sockColor: ''
            },
            vest: '',
            type: null,
            lockListOnStage: 0,
            btnText: '保存'
        };
    },
    created() {
        this.type = this.$route.query.type
        this.lockListOnStage = Number(this.$route.query.lockListOnStage)
        if (this.lockListOnStage == 1) { 
            this.btnText = '返回'
        }
        this.getTeamClothesColors()
    },
    methods: {
        getTeamClothesColors() {
            const routerParams = this.$route.params
            getTeamClothesColors(routerParams).then(res => {
                console.log('res', res)
                if (res.data.clothesColors) {
                    const clothesColors = JSON.parse(res.data.clothesColors)
                    this.teamColor = clothesColors.teamColor
                    this.goalkeeperColor = clothesColors.goalkeeperColor
                    this.vest = clothesColors.vest
                    return
                }
                const clothesColorDescription = res.data.clothesColorDescription.split(',')
                console.log('clothesColorDescription', clothesColorDescription)
                let colors = {}
                clothesColorDescription.forEach(item => {
                    const [key, value] = item.split(':')
                    colors = {
                        ...colors,
                        [key]: value
                    }
                })
                let teamStr = this.type == 'home' ? '主场' : '客场'
                this.teamColor = {
                    shirtColor: colors[teamStr + '上衣'],
                    shortColor: colors[teamStr + '短裤'],
                    sockColor: colors[teamStr + '球袜']
                }
                this.goalkeeperColor = {
                    shirtColor: colors[teamStr + '守门员上衣'],
                    shortColor: colors[teamStr + '守门员短裤'],
                    sockColor: colors[teamStr + '守门员球袜']
                }
                this.vest = colors[teamStr + '替补背心']
            })
        },
        save() {
            if (this.lockListOnStage == 1) {
                this.$router.go(-1)
                return
            }
            const routerParams = this.$route.params
            const params = {
                ...routerParams
            }
            const data = {
                teamColor: this.teamColor,
                goalkeeperColor: this.goalkeeperColor,
                vest: this.vest
            }
            const clothesColors = JSON.stringify(data)
            updateClothesColors(params, {clothesColors}).then(res => { 
                if (res) {
                    this.$router.go(-1)
                }
            })
        }
    },
};
</script>

<style scoped lang="scss">
.clothes-color{
    background-color: #F8F8F8;
    min-height: 100vh;
  .title{
    font-size: 13px;
    color: #676767;
    padding: 0 16px;
    height: 38px;
    line-height: 38px;
    background: #F0F0F3;
    margin-bottom: 10px;
  }
  .content{
    padding: 0 10px;
    .item{
        height: 50px;
        border-radius: 5px;
        background: #FFFFFF;
        padding: 0 14px;
        margin-bottom: 6px;
        .label{
            font-size: 15px;
            color: #666666;
        }
        .value{
            flex: 1;
            text-align: right;
            input{
                text-align: right;
                width: 100%;
                height: 100%;
                border: none;
                outline: none;
                color: #535353;
                &:disabled {
                    background-color: #FFF;
                    color: #999;
                    cursor: not-allowed;
                }
            }
        }
    }
  }
  .footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
    padding: 0 16px;
    background-color: #F8F8F8;
    .btn{
        height: 47px;
        border-radius: 6px;
        line-height: 47px;
        text-align: center;
        background: #0FAC7F;
        color: #FFFFFF;
        font-size: 16px;
        font-weight: 500;
    }
  }
}
</style>
